"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reducer;
exports.updateComponator = exports.initComponator = exports.getData = void 0;
var _excluded = ["type", "key"],
    _excluded2 = ["key"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var actions = ['CMP_INIT', 'CMP_UPDATE', 'CLEAR_ALL_SETTINGS'];
var initData = {
  input: [],
  output: [],
  displayedField: null,
  indexedField: null
};
/* selectors */

var getData = function getData(data, key) {
  return data[key] || initData;
};
/* updaters */

/* reducer */


exports.getData = getData;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (actions.includes(action.type)) {
    var type = action.type,
        key = action.key,
        rest = _objectWithoutProperties(action, _excluded);

    var activeKey = key || state.activeKey;
    var prevData = state[activeKey];

    switch (type) {
      case 'CMP_INIT':
        {
          var newData = prevData || rest;
          newData.indexedField = newData.indexedField || newData.displayedField;
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({
            activeKey: activeKey
          }, activeKey, _objectSpread(_objectSpread({}, prevData || initData), newData)));
        }

      case 'CMP_UPDATE':
        {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, activeKey, _objectSpread(_objectSpread({}, prevData), rest)));
        }

      case 'CLEAR_ALL_SETTINGS':
        {
          return {};
        }

      default:
        return state;
    }
  }

  return state;
}
/* action creators */


var initComponator = function initComponator(_ref) {
  var key = _ref.key,
      rest = _objectWithoutProperties(_ref, _excluded2);

  return _objectSpread({
    type: 'CMP_INIT',
    key: key
  }, rest);
};

exports.initComponator = initComponator;

var updateComponator = function updateComponator(data) {
  return _objectSpread({
    type: 'CMP_UPDATE'
  }, data);
};

exports.updateComponator = updateComponator;